export default "__VITE_ASSET__BsmwH4Z___"